import {translateKey} from "../values";
import {
    LayoutDashboard,
    UsersRound,
    Wallet,
    Settings,
    Images,
    Paperclip,
    StickyNote, FileChartLine, BadgeDollarSign, ChartCandlestick, ChartPie, ScrollText, Headset,

} from "lucide-react";

export const getRoutes = function () {
    return [
        {
            id: 'dashboard',
            title: translateKey('dashboard'),
            type: 'item',
            icon: <LayoutDashboard className="lucide-icon-sidebar"/>,
            url: '/',
        },
        {
            id: 'manageStocks',
            title: translateKey('manageStocks'),
            type: 'item',
            url: '/manage/stocks/view-all',
            icon: <ChartCandlestick className="lucide-icon-sidebar"/>,
            exact:true,
            permission: 'manageSettings',
        },
        {
            id: 'manageProfits',
            title: translateKey('manageProfits'),
            type: 'item',
            url: '/manage/profits/view-all',
            icon: <ChartPie className="lucide-icon-sidebar"/>,
            exact:true,
            permission: 'manageSettings',
        },
        {
            id: 'bsRequests',
            title: translateKey('bsRequests'),
            icon: <BadgeDollarSign className="lucide-icon-sidebar"/>,
            type: 'item',
            url: '/bs-requests/view-all',
        },
        {
            id: 'installmentsList',
            title: translateKey('installmentsList'),
            icon: <ScrollText className="lucide-icon-sidebar"/>,
            type: 'item',
            url: '/installments/view-all',
        },
        {
            id: 'stockPrice',
            title: translateKey('stockPrice'),
            type: 'item',
            url: '/manage/stocks/price',
            icon: <FileChartLine className="lucide-icon-sidebar"/>,
            exact:true,
            permission: 'manageSettings',
        },
        {
            id: 'usersList',
            title: translateKey('userslist'),
            type: 'item',
            url: '/manage/users/view-all',
            icon: <UsersRound className="lucide-icon-sidebar"/>,
            exact:true,
            permission: 'manageSettings',
        },
        {
            id: 'manageWallets',
            title: translateKey('manageWallets'),
            icon: <Wallet className="lucide-icon-sidebar"/>,
            permission: 'managePayments',
            type: 'item',
            url: '/manage/wallets/view-all',
        },
        {
            id: 'support',
            title: translateKey('support'),
            type: 'item',
            url: '/manage/support',
            icon: <Headset className="lucide-icon-sidebar"/>,
            exact:true,
            permission: 'manageSettings',
        },
        {
            id: 'changeSettings',
            title: translateKey('changeSettings'),
            type: 'item',
            icon: <Settings className="lucide-icon-sidebar"/>,
            url: '/manage/setting/view-all',
            roles: ['admin'],
            permission: "manageSettings",
        },
        {
            id: 'managePages',
            title: translateKey('managePages'),
            type: 'item',
            icon: <StickyNote className="lucide-icon-sidebar"/>,
            url: '/manage/pages/view-all',
            roles: ['admin'],
            permission: "manageSettings",
        },
        /*{
            id: 'manageBanners',
            title: translateKey('manageBanners'),
            type: 'item',
            icon: <Images className="lucide-icon-sidebar"/>,
            url: '/manage/setting/banners',
            roles: ['admin'],
            permission: "manageSettings",
        },*/
        {
            id: 'fileManager',
            title: translateKey('fileManager'),
            type: 'item',
            icon: <Paperclip className="lucide-icon-sidebar"/>,
            url: '/file-manager',
            roles: ['admin'],
            permission: "manageSettings",
        },
        {
            id: 'myStocks',
            title: translateKey('myStocks'),
            type: 'item',
            url: '/stocks/view-all',
            icon: <ChartCandlestick className="lucide-icon-sidebar"/>,
            exact:true,
            roles: ['user'],
        },
        {
            id: 'myProfits',
            title: translateKey('myProfits'),
            type: 'item',
            url: '/profits/view-all',
            icon: <ChartPie className="lucide-icon-sidebar"/>,
            exact:true,
            roles: ['user'],
        },
        {
            id: 'myAccount',
            title: translateKey('myAccount'),
            icon: <UsersRound className="lucide-icon-sidebar"/>,
            type: 'item',
            url: '/user/account',
            roles: ['user'],
        }, 
        {
            id: 'wallets',
            title: translateKey('myTransactions'),
            icon: <Wallet className="lucide-icon-sidebar"/>,
            type: 'item',
            url: '/user/wallet',
            roles: ['user'],
        },
        {
            id: 'support',
            title: translateKey('support'),
            type: 'item',
            url: '/user/support',
            icon: <Headset className="lucide-icon-sidebar"/>,
            exact:true,
            roles: ['user'],
        },
    ]
}

